<template>
  <tr>
    <td data-label="Code">
      {{ invoiceCode.code }}
    </td>
    <td data-label="Description">
      {{ invoiceCode.description }}
    </td>
    <td class="text-center button-2">
      <button class="my-2 btn btn-warning" @click="editCode()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteCode()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'InvoiceCodeRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    invoiceCode () {
      return {
        ...this.object
      }
    }
  },
  methods: {
    editCode () {
      this.$emit('edit', { permalink: 'editInvoiceCode', uuid: this.invoiceCode.uuid })
    },
    deleteCode () {
      this.$emit('deleteObject', { permalink: 'deleteInvoiceCode', uuid: this.invoiceCode.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/InvoiceCode.vue